import React, { useState, useEffect, lazy } from "react";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import IosShareIcon from "@mui/icons-material/IosShare";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";

import "./ViewBlog.scss";
import "./Blogs.scss";
import "./Responsive.scss";

import "./css/style.css";
import "./css/alignment.css";
import "./css/style-editor.css";
import "./css/style-rtl.css";
import "./css/social.css";

import HeaderV2 from "../../Components/HeaderV2/HeaderV2";
import ResFooter from "../../Components/Home/CADFooter/ResFooter";
import moment from "moment";
import ContentLoader from "react-content-loader";
import $ from "jquery";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MetaDecorator from "../../Components/MetaDecorator/MetaDecorator";
import BlogBanner from "./Components/BlogBanner";
import SideBanner from "./Components/SideBanner";

import { client } from "./lib/client";
import { PortableText } from "@portabletext/react";
import urlBuilder from "@sanity/image-url";
import { getImageDimensions } from "@sanity/asset-utils";
import { TableOfContents } from "./TableOfContent";
import { ClickAwayListener } from "@mui/base";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

//ICON
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/Twitter";
//ICON
const Questions = lazy(() => import("../../Components/Questions/Questions"));

function ViewBlog() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const BlogID = params.blogID;
  const [loadingBlog, setLoadingBlog] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [isCopied, setIsCopied] = useState(false);
  const shareUrl = `https://leapon.tech/blog/${BlogID}`;
  const shareTitle = "Check out this blog!";

  useEffect(() => {
    getBlog();
    $(window).scrollTop(0);
  }, [BlogID]);

  const getBlog = () => {
    setLoadingBlog(true);
    client
      .fetch(
        `*[slug.current == "${BlogID}"] {
        title,
        body,
        publishedAt,
        minToRead,
        metaDescription,
        metaTitle,
          "author": author->{
          name,
          image {
          asset -> {
            _id,
            url
            },
          },
          },
       "slug": slug.current,
        "categories": categories[]->{
        title,
        "category_id":_id
        },
        mainImage {
          asset -> {
            _id,
            url
          },
          alt
        },
        "headings": body[length(style) == 2 && string::startsWith(style, "h2")],
        faqs[]{
    "id": _key,
    ques,
    ans,
    _type
  }
      }`
      )
      .then((res) => {
        setLoadingBlog(false);
        if (res) {
          setBlogs(res[0]);
          getRelatedBLog(res[0].categories[0].category_id);
          $(document).ready(function () {
            if (res[0].metaDescription) {
              const ogDescription = document.querySelector(
                'meta[property="og:description"]'
              );
              if (ogDescription) {
                ogDescription.setAttribute("content", res[0].metaDescription);
              }
            }

            const ogTitle = document.querySelector('meta[property="og:title"]');
            if (ogTitle) {
              if (res[0].metaTitle) {
                ogTitle.setAttribute("content", res[0].metaTitle);
              } else {
                ogTitle.setAttribute("content", res[0].title);
              }
            }
          });
        }
      })
      .catch((err) => {
        setLoadingBlog(false);
        console.error("Error fetching blog:", err);
      });
  };

  const SampleImageComponent = ({ value, isInline }) => {
    const { width, height } = getImageDimensions(value);
    return (
      <img
        src={urlBuilder(client)
          .image(value)
          .width(isInline ? 100 : 800)
          .fit("max")
          .auto("format")
          .url()}
        alt={value.alt || " "}
        // loading="lazy"
        style={{
          // Display alongside text if image appears inside a block text span
          display: isInline ? "inline-block" : "block",
          marginBottom: "20px",
          // Avoid jumping around with aspect-ratio CSS property
          aspectRatio: width / height,
        }}
        loading="lazy"
      />
    );
  };

  const components = {
    types: {
      image: SampleImageComponent,
      banner: ({ value }) => {
        const { variant } = value;
        switch (variant) {
          case "try-leapon":
            return <BlogBanner cta="Try Leapon" />;
          case "book-demo":
            return <BlogBanner cta="Book a Demo" />;
          default:
            return null;
        }
      },
      actionButton: ({ value }) => {
        const { variant } = value;
        switch (variant) {
          case "try-leapon":
            return (
              <Link
                to="https://leapon.me/signup/"
                className="cta-btn blog_actionButton"
              >
                Try Leapon
              </Link>
            );
          case "book-demo":
            return (
              <Link
                to="/get-demo#demo-booking"
                className="cta-btn blog_actionButton"
              >
                Book a Demo
              </Link>
            );
          default:
            return null;
        }
      },
    },
    block: {
      // Helper function to extract text content from children recursively
      extractText: (children) => {
        return children
          .map((child) => {
            if (typeof child === "string") {
              return child;
            } else if (child?.props?.children) {
              return components.block.extractText(
                Array.isArray(child.props.children)
                  ? child.props.children
                  : [child.props.children]
              );
            } else {
              return "";
            }
          })
          .join("");
      },
      h1: ({ children }) => {
        const textContent = components.block.extractText(children);
        const id = textContent.replace(/\s+/g, "-").toLowerCase();
        return <h1 id={id}>{children}</h1>;
      },
      h2: ({ children }) => {
        const textContent = components.block.extractText(children);
        const id = textContent.replace(/\s+/g, "-").toLowerCase();
        return <h2 id={id}>{children}</h2>;
      },
      h3: ({ children }) => {
        const textContent = components.block.extractText(children);
        const id = textContent.replace(/\s+/g, "-").toLowerCase();
        return (
          <h3 className="h3" id={id}>
            {children}
          </h3>
        );
      },
      h4: ({ children }) => {
        const textContent = components.block.extractText(children);
        const id = textContent.replace(/\s+/g, "-").toLowerCase();
        return <h4 id={id}>{children}</h4>;
      },
      blockquote: ({ children }) => {
        return (
          <blockquote className="custom-blockquote">{children}</blockquote>
        );
      },
      normal: ({ children }) => (
        <p style={{ marginBottom: "20px" }}>{children}</p>
      ),
    },

    marks: {
      link: ({ children, value }) => {
        const href = value?.href || "#";
        return (
          <a
            href={href}
            style={{
              textDecoration: "none",
              borderBottom: "2px solid",
              borderBottomColor: "#006dff4d",
              position: "relative",
            }}
          >
            {children}
          </a>
        );
      },
    },
  };

  const getRelatedBLog = (category) => {
    client
      .fetch(
        `*[_type == "post" && "${category}" in categories[]._ref && slug.current != "${BlogID}"][0...3]{
  title,
  "slug": slug.current,
   "author": author->{
          name,
          image {
          asset -> {
            _id,
            url
            },
          },
          },
  "categories": categories[]->{
    description,
    title,
    "slug": slug.current,
    "category_id":_id
  },
  mainImage{
    asset->{
      url
    },
    alt
  },
  publishedAt,
    body[0...5],
    metaDescription
} | order(publishedAt desc)`
      )
      .then((res) => {
        setRelatedPosts(res);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="view_blog">
      <HeaderV2 />
      {blogs ? (
        <MetaDecorator
          title={blogs.metaTitle}
          description={blogs.metaDescription}
          imageUrl={blogs.mainImage?.asset?.url}
        />
      ) : (
        ""
      )}
      <div className="blogs-container view_blog_con">
        <div className="blogs-con-wrapper">
          <div className="view-hero-section">
            <div className="blogs-hero-section-wrapper">
              {loadingBlog ? (
                <div className="skeleton-loader">
                  <ContentLoader viewBox="0 0 300 280" height={640}>
                    <rect
                      x="3"
                      y="3"
                      rx="10"
                      ry="10"
                      width="300"
                      height="180"
                    />
                    <rect x="6" y="190" rx="0" ry="0" width="292" height="20" />
                    <rect x="4" y="215" rx="0" ry="0" width="239" height="20" />
                    <rect x="4" y="242" rx="0" ry="0" width="274" height="20" />
                  </ContentLoader>
                </div>
              ) : (
                <div className="view-blog-hero">
                  <div className="view-blog-hero-wrapper">
                    <div>
                      <h1 className="view-blog-title">
                        {location.state !== null
                          ? location.state.data.title
                          : blogs !== undefined
                          ? blogs.title
                          : ""}
                      </h1>
                      <div className="author_share_con author_share_con1">
                        <div className="view_author_sec">
                          <img
                            src={blogs.author?.image?.asset?.url}
                            alt="Author Pic"
                            loading="lazy"
                          />
                          <div className="view_author_sec_text">
                          <p>{blogs.author?.name}</p>{" "}
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span>
                                {moment(blogs.publishedAt).format("MMM D")}
                              </span>
                              {blogs.minToRead !== null && (
                                <div style={{ display: "flex" }}>
                                  <span className="dot_seperator">
                                    <FiberManualRecordIcon className="icon" />
                                  </span>
                                  <span>{blogs.minToRead} min read</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="share_btns">
                            {isCopied && (
                              <div class="alert alert-success" role="alert">
                                Copied
                              </div>
                            )}
                            <button
                              onClick={() => {
                                copy(shareUrl);
                                setIsCopied(true);
                                setTimeout(() => {
                                  setIsCopied(false);
                                }, 3000);
                              }}
                            >
                              <ContentCopyIcon fontSize="medium" />
                            </button>
                            <button onClick={() => setShowShare(true)}>
                              <IosShareIcon fontSize="medium" />
                            </button>
                            {showShare && (
                              <ClickAwayListener
                                onClickAway={() => setShowShare(false)}
                              >
                                <div className="blog_share_con">
                                  <TwitterShareButton
                                    className="share_btn"
                                    url={shareUrl}
                                    title={shareTitle}
                                  >
                                    <XIcon className="icon" />
                                    Share on X
                                  </TwitterShareButton>

                                  <LinkedinShareButton
                                    className="share_btn"
                                    url={shareUrl}
                                    title={shareTitle}
                                  >
                                    <LinkedInIcon className="icon" />
                                    Share on LinkedIn
                                  </LinkedinShareButton>
                                  <FacebookShareButton
                                    className="share_btn"
                                    url={shareUrl}
                                    quote={shareTitle}
                                  >
                                    <FacebookIcon className="icon" />
                                    Share on Facebook
                                  </FacebookShareButton>
                                </div>
                              </ClickAwayListener>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="view-blog-hero-btn">
                        <Link
                          to="https://leapon.me/signup/"
                          className="cta-btn"
                        >
                          Try Leapon
                        </Link>
                        <Link
                          to="/get-demo#demo-booking"
                          className="btn-secondary-outline"
                        >
                          Book a Demo
                        </Link>
                      </div>
                    </div>
                    <img
                      className="lazyloaded article__featured-image"
                      src={blogs.mainImage?.asset?.url}
                      alt={blogs.mainImage?.asset?.alt}
                      loading="lazy"
                    />
                  </div>
                  <TableOfContents content={blogs.headings} />
                  <div className="view-blog-body-wrapper">
                    <div className="view-blog-body">
                      <PortableText
                        value={blogs.body}
                        components={components}
                      />{" "}
                      {blogs.faqs && <Questions Questions={blogs.faqs} />}
                      <div
                        className="author_share_con"
                        style={{ marginBottom: 0 }}
                      >
                        <div className="category_con">
                          {blogs.categories?.map((item, index) => {
                            return (
                              <button
                                className="hover_remove"
                                key={index + "category"}
                              >
                                {item.title}
                              </button>
                            );
                          })}
                        </div>
                        <div className="share_btns">
                          {isCopied && (
                            <div class="alert alert-success" role="alert">
                              Copied
                            </div>
                          )}
                          <button
                            onClick={() => {
                              copy(shareUrl);
                              setIsCopied(true);
                              setTimeout(() => {
                                setIsCopied(false);
                              }, 3000);
                            }}
                          >
                            <ContentCopyIcon fontSize="medium" />
                          </button>
                          <button onClick={() => setShowShare(true)}>
                            <IosShareIcon fontSize="medium" />
                          </button>
                          {showShare && (
                            <ClickAwayListener
                              onClickAway={() => setShowShare(false)}
                            >
                              <div
                                className="blog_share_con"
                                style={{ right: 80, top: "-50px" }}
                              >
                                <TwitterShareButton
                                  className="share_btn"
                                  url={shareUrl}
                                  title={shareTitle}
                                >
                                  <XIcon className="icon" />
                                  Share on X
                                </TwitterShareButton>

                                <LinkedinShareButton
                                  className="share_btn"
                                  url={shareUrl}
                                  title={shareTitle}
                                >
                                  <LinkedInIcon className="icon" />
                                  Share on LinkedIn
                                </LinkedinShareButton>
                                <FacebookShareButton
                                  className="share_btn"
                                  url={shareUrl}
                                  quote={shareTitle}
                                >
                                  <FacebookIcon className="icon" />
                                  Share on Facebook
                                </FacebookShareButton>
                              </div>
                            </ClickAwayListener>
                          )}
                        </div>
                      </div>
                    </div>
                    <SideBanner />
                  </div>
                  <div className="blog_interest">
                    <h5>build Connections & drive business growth</h5>
                    <Link to="https://leapon.me/signup/" className="cta-btn">
                      Try Leapon
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          {relatedPosts.length > 0 && (
            <div className="recent-blogs">
              <p className="recent-blogs-title">More From Leapon</p>
              <div className="blogs-features-card">
                {relatedPosts.map((item, index) => {
                  return (
                    <button
                      to={"/blog/" + item.slug}
                      key={index}
                      onClick={() =>
                        navigate("/blog/" + item.slug, {
                          state: {
                            data: item,
                            featured_media: item.mainImage?.asset?.url || "",
                          },
                        })
                      }
                      className="blogs-features-card-item"
                    >
                      <span className="also_tagged_text">
                        Also tagged {blogs.categories[0].title}
                      </span>
                      <img
                        className="blogs-features-card-img"
                        src={item.mainImage.asset.url}
                        alt={item.mainImage.alt || "featured"}
                        loading="lazy"
                      />
                      <div className="blog_content_btm">
                        <p className="blogs-features-card-title">
                          {item.title}
                        </p>
                        <div
                          style={{ marginTop: 0 }}
                          className="author_share_con"
                        >
                          <div className="view_author_sec">
                            <img
                              src={blogs.author?.image?.asset?.url}
                              alt="Author Pic"
                              loading="lazy"
                            />
                            <div className="view_author_sec_text">
                              <p>{blogs.author?.name}</p>
                              <span>
                                {moment(item.publishedAt).format("MMM D")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        <ResFooter />
      </div>
    </div>
  );
}
export default ViewBlog;
